const { EntityApi } = require('../common')
const { wrapEntityApi } = require('../utils/wrap-api')
const tools = require('./tools')
const api = require('./api')
const PGAdapter = require('../common/pg-adapter')
const get = require('lodash/get')

const rawMethods = {...api, tools}
const ServiceDataAdapter = require('./data-access/service-data-adapter')

class ServiceApi extends EntityApi {
  constructor (state, restAdapter, logger, pgConnection) {
    const { user, productsDB } = state
    const adapter = new ServiceDataAdapter(user, productsDB, restAdapter)
    super(adapter)

    // TODO: remove this when all raw methods have been ported
    const apiMethods = wrapEntityApi(rawMethods, state)
    Object.assign(this, apiMethods)

    if (pgConnection) {
      const username = get(state, 'user.name')
      this.pgAdapter = new ServicePGAdapter({ pgConnection, username, logger })
    }
  }
}

class ServicePGAdapter extends PGAdapter {
  constructor ({ pgConnection, username, logger }) {
    const columns = [
      'id',
      'fsid',
      'name',
      'program_id',
      'created_at',
      'updated_at'
    ]

    super(pgConnection, 'avocado.data_service', username, columns, 'id', {}, logger)
  }
}

module.exports = rawMethods
module.exports.ServiceApi = ServiceApi
